import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { ImportedPlansOverview } from "./ImportedPlansOverview";

const REFETCH_INTERVAL = 3000;

interface ImportedPlansOverviewWrapperProps {
  readonly loadData: boolean;
  readonly closeDialog: () => void;
}

export function ImportedPlansOverviewWrapper({
  loadData,
  closeDialog,
}: ImportedPlansOverviewWrapperProps): React.JSX.Element {
  const { knopClient } = useKnopClient();
  const { data, error, isLoading } = useQuery({
    enabled: loadData,
    queryKey: ["list-saved-instances"],
    queryFn: () => knopClient.getInstanceList(),
    refetchInterval: REFETCH_INTERVAL,
    // Used to prevent the page from rerendering each time new data is fetched.
    structuralSharing: (oldData, newData) =>
      JSON.stringify(oldData) === JSON.stringify(newData) ? oldData : newData,
  });

  if (error) return <ErrorState />;
  return (
    <ImportedPlansOverview instances={data ?? []} isLoading={isLoading} closeDialog={closeDialog} />
  );
}
